/**
 * 题目表单
 * @description 题目新增、编辑
 * @author mll
 * @date 2020-1-22
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, message, Upload } from 'antd'
import { component_tool,framework_tool } from '@/tool'
import {WizClassifySelectRe} from "@/containers/common"
import ChoiceForm from './choiceForm'
let { WizAvatarUpload, WizFileUpload, WizOssUpload,ossFileUtils } = framework_tool
let {
    WizButton,
    WizSelect,
    WizTooltip,
    WizInput,
    WizIcon,
    WizSwitch,
    WizDatePicker,
    WizRow,
    WizCol,
    WizCard,
    WizRadio,
    WizDivider,
    WizCheckbox,
  Wizmessage,
  WizTreeSelectList
} = component_tool;
let WizForm = Form
let Item = Form.Item
let Option = WizSelect.Option

/**
 * 此组件没有继承WizComponent，因为需要使用Form.create()该组件
 * 继承WizComponent后 form的部分功能缺失了
 * 初步怀疑是WizComponent修改了生命周期的钩子导致的
 * by mll 2020-2-4
 */

class SubjectForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            type: 'Subjective',
            answerSize: 0,
            modalVisible: false,
            img: ''
        }
        this.answerSize = 0;
        this.isStart = true;
    }
    _propInfo(nextProps, nextState) {
        let { propInfo, treeData, form } = nextProps
        if (propInfo && this.isStart) {
            if (propInfo.isStart) {
                if (propInfo['type']) {
                    nextState.type = propInfo['type']
                }
                if (propInfo.img) {
                    nextState.img = propInfo.img
                }
                if (propInfo.answer) {
                    form.answer = propInfo.answer
                    if (propInfo.type === "Completion") {
                        this.changeCompletionDefault(propInfo)
                        nextState.answerSize = propInfo.answerSize
                    } else {
                        nextState.answerSize = propInfo.options.length
                    }
                }
                this.isStart = false
            }
        }

        return true
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this._propInfo(nextProps, nextState);
    }
    /**
     * foreach options
     * @param {*} options
     */
    _renderOptions(options) {
        if (options && options.length) {
            let { rowKey, rowName } = this.props
            //return null
            return options.map((row, i) => this._renderOption(row))
        }
        return null
    }

    /**
     * WizSelect.Option
     * @param {*} row
     * @param {*} rowKey
     * @param {*} rowName
     * @param {*} i
     */
    _renderOption(row) {
        if (row) {
            return (
                <Option key={row['key']} value={row['value']}>
                    {row['title']}
                </Option>
            )
        }
    }

    getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    /**
     * 表单基础内容
     */
    _base() {
        const { getFieldDecorator } = this.props.form;
        const { propInfo, treeData, treeSelectList,selects } = this.props;
        let TreeSelectList = treeSelectList
        return [
            /**
             * 题目分类
             */
            //hasFeedback去除校验标识
            <Item label="题目分类" >
                {getFieldDecorator('classify', {
                    initialValue: propInfo.classify,
                    rules: [
                        { required: true, message: '请选择题目分类', type: 'array' },
                    ],
                })(
                  <WizClassifySelectRe
                    returnKey={true}
                    apiPath={'questionType/normalNodeList'}
                    apiProps={{type: 2, state: 1}}
                    initSelects={selects ? selects : []}
                    wizTreeSelectListProps={{
                      item: {
                        icon: 'unordered-list',
                        title: '题目分类',
                        tips: '请勾选所属题目分类'
                      },
                      multiple: true,
                      treeCheckable: false,
                      checkable: true,
                      showSelectList: true,
                      treeProps: {checkStrictly: true}
                    }}

                  />
                    // <TreeSelectList ref={(r) => this.treeSelectListRef = r && r.getWrappedInstance()} form={this.props.form} selects={this.props.selects} type='2' />
                )}
            </Item>,
            /**
             * 题目类型
             */
            <Item label="题目类型" >
                {getFieldDecorator('type', {
                    initialValue: propInfo.type,
                    rules: [{ required: true, message: '请选择题目类型' }],
                })(
                    <WizSelect
                        placeholder="请选择题目类型"
                        onChange={this._changeType}
                    >
                        <Option value="Single">单选题</Option>
                        <Option value="Multiple">多选题</Option>
                        <Option value="Judgement">判断题</Option>
                        <Option value="Completion">填空题</Option>
                        <Option value="Subjective">主观题</Option>
                        <Option value="FileUpload">文件上传题</Option>
                        <Option value="Sort">排序题</Option>
                    </WizSelect>,
                )}
            </Item>,
            <Item label="题目图片"
                key={this.state.img}
                label={
                    <span>
                        题目图片&nbsp;
                        <WizTooltip title="请上传大小不超过1MB,图片尺寸建议400*266">
                            <WizIcon type="question-circle-o" />
                        </WizTooltip>
                    </span>
                }>
                {getFieldDecorator('questionImg', {
                    initialValue: (propInfo && propInfo.img) ? [
                        {
                            fileId:propInfo.img,
                        }
                    ] : [],
                })(
                    <WizAvatarUpload
                        accept={'.jpg, .jpeg, .png'}
                        listType={'picture-card'}
                        aspectRatio={400 / 266}
                        beforeUpload={(file) => {
                            const isLt1M = file.size / 1024 / 1024 < 1;
                            if (!isLt1M) {
                                message.error('图片不得超过1MB!');
                            }
                            return isLt1M;
                        }}
                    />
                )}

            </Item>,
            /**
             * 题目编码
             */
            <Item label="题目编码" >
                {getFieldDecorator('code', {
                    initialValue: propInfo.code,
                    rules: [{ required: true, message: '请输入题目编码', whitespace: true }],
                })(<WizInput maxLength={25}  placeholder='请输入题目编码,最多25字' />)}
            </Item>,
            /**
             * 题目
             */
            <Item label="题目" >
                {getFieldDecorator('subject', {
                    initialValue: propInfo.subject,
                    rules: [{ required: true, message: '请输入题目内容', whitespace: true }],
                })(<WizInput.TextArea maxLength={200} placeholder='请输入题目内容,最多200字' />)}
            </Item>,

            /**
             * 难度级别
             */
            <Item label="难度级别">
                {getFieldDecorator('difficulty', {
                    initialValue: propInfo.difficulty ? propInfo.difficulty : 'low'
                })(
                    <WizSelect placeholder="请选择难度级别">
                        <Option value="low">低</Option>
                        <Option value="middle">中</Option>
                        <Option value="high">高</Option>
                    </WizSelect>,
                )}
            </Item>,
        ]
    }

    /**
     * 根据题目类型渲染不同的Form
     * 单选 Single, 多选 Multiple, 判断 Judgement, 填空 Completion, 主观 Subjective
     */
    _subject() {
        let { type } = this.state
        if (type === 'Single' || type === 'Multiple') {
            return this._select()
        } else if (type === 'Judgement') {
            return this._judgement()
        } else if (type === 'Completion') {
            return this._completion()
        } else if (type === 'Subjective') {
          return this._subjective()
        } else if(type === 'FileUpload') {
          return this._fileUpload()
        } else if(type === 'Sort') {
          return this._sort()
        } else {
            return []
        }
    }

    /**
     * 设置单选/多选的选项
     */
    changeOptions = data => {
        const { form } = this.props;
        this.setState({
            answerSize: data.length
        }, () => {
            form.setFieldsValue({
                options: data
            });
        })
    }

    /**
     * 单选/多选
     */
    _select() {
        const { type } = this.state
        const { getFieldDecorator } = this.props.form;
        const { propInfo } = this.props;
        let choiceFormProps = {
          dataSource: undefined,
        }
        if (propInfo && propInfo.options && propInfo.options.length) {
            choiceFormProps['dataSource'] = [...propInfo.options]
        }
        return [
            <Item label="选择设置" key={type}>
                {getFieldDecorator('options', {
                    initialValue: propInfo.options
                })(
                    <ChoiceForm
                        ref={(r) => { this.choiceFormRef = r }}
                        key={propInfo ? propInfo.choiceFormKey : 0}
                        getDataSource={this.changeOptions}
                        {...choiceFormProps}
                    />
                )}
            </Item>,
            <div>{this._selectAnswer()}</div>
        ]
    }

    /**
     * 选择题的答案区域
     */
    _selectAnswer() {
        const { setFieldsValue } = this.props.form
        const { getFieldDecorator } = this.props.form;
        const { propInfo } = this.props;
        const { answerSize, type } = this.state;
        let Com = type === 'Single' ? WizRadio : WizCheckbox
        let answer = propInfo.type === type ? propInfo.answer : undefined
        let opt = []
        if (answerSize <= 0) {
            return
        } else {
            for (let i = 0; i < answerSize; i++) {
                opt.push(<Com value={i}>{String.fromCharCode(i + 65)}</Com>)
            }
            if (this.answerSize !== answerSize) {
                setFieldsValue({
                    answer: this.props.form.answer
                })
                this.answerSize = answerSize;
            } else {

            }
            return (
                <Item label="答案设置" key={type}>
                    {getFieldDecorator('answer', {
                        initialValue: answer,
                        rules: [
                            { required: true, message: '请选择正确答案' },
                        ],
                    })(
                        <Com.Group>
                            {opt}
                        </Com.Group>,
                    )}
                </Item>
            )
        }
    }

    /**
     * 判断
     */
    _judgement() {
        const { getFieldDecorator } = this.props.form;
        const { propInfo } = this.props;
        return [
            <Item label="答案设置">
                {getFieldDecorator('answer', {
                    initialValue: propInfo.answer,
                    rules: [
                        { required: true, message: '请选择正确答案' },
                        { pattern: /^(1)|(0)$/, message: '请选择正确答案' },
                    ],
                })(
                    <WizRadio.Group>
                        <WizRadio value={0}>正确</WizRadio>
                        <WizRadio value={1}>错误</WizRadio>
                    </WizRadio.Group>,
                )}
            </Item>
        ]
    }

    /**
    * 填空题减少选项
    */
    remove = (k, key, idkey, answerKey) => {
        const { form } = this.props;
        const keys = form.getFieldValue(key);
        if (keys.length === 1 && answerKey === 'answer[0]') {
            return;
        }
        let _keys = keys.filter(e => e !== k);
        if (_keys.length) {
            for (let i = 0; i < _keys.length; i++) {
                let _key = _keys[i];
                form.setFieldsValue(
                    { [answerKey + `[${i}]`]: form.getFieldValue(answerKey + `[${_key}]`) }
                )
            }
        }
        let nextKeys = []
        for (let i = 0; i < keys.length - 1; i++) {
            nextKeys.push(i)
        }
        form.setFieldsValue({
            [key]: nextKeys
        });
        this[idkey]--
        if (this[idkey] === 0) {
            this.changeAllAnswer()
        }

    };

    /**
     * 填空题：当备选答案没有时整理所有答案的顺序，并且删除没有备选答案的答案区域
     */
    changeAllAnswer() {
        let { form } = this.props;
        let { answerSize } = this.state;
        let changeAnswer = (i) => {
            let completionAnswer = 'completionAnswer' + i;
            let nextCompletionAnswer = 'completionAnswer' + (i + 1);
            if (this[completionAnswer] === 0 && this[nextCompletionAnswer] > 0) {
                form.setFieldsValue({
                    ['keys' + i]: form.getFieldValue('keys' + (i + 1)),
                    ['answer' + i]: form.getFieldValue('answer' + (i + 1))
                })
                this[completionAnswer] = this[nextCompletionAnswer]
                this[nextCompletionAnswer] = 0
            }
        }
        for (let i = 0; i < answerSize; i++) {
            changeAnswer(i)
        }
        this.setState({ answerSize: --answerSize })
    }

    /**
     * 填空题增加选项
     */
    add = (key, idkey) => {
        const { form } = this.props;
        const keys = form.getFieldValue(key);
        let nextKeys = []
        if (keys) {
            for (let i = 0; i < keys.length; i++) {
                nextKeys.push(i)
            }
        }
        nextKeys = nextKeys.concat(this[idkey]++);
        form.setFieldsValue({
            [key]: nextKeys,
        });
    };

    /**
     * 填空
     */
    _completion() {
        let { answerSize } = this.state;
        const { getFieldDecorator } = this.props.form;
        const { form, propInfo } = this.props;
        let completion = {}
        if (propInfo) {
            if (propInfo.answer) {
                completion = propInfo.answer
            }
        }

        let r = []
        //答案内容的循环
        for (let i = 0; i < answerSize; i++) {
            let completionAnswerKey = 'completionAnswer' + i;
            if (this[completionAnswerKey] === undefined) {
                this[completionAnswerKey] = 0
            }
            r.push(this._completionAnswer(completion, 'keys' + i, 'answer' + i, completionAnswerKey, i))
        }
        //添加答案的按钮
        r.push(this._addCompletionAnswer())
        return r;
    }

    /**
     * 添加填空答案
     */
    _addCompletionAnswer() {
        const formItemLayoutWithOutLabel = {
            wrapperCol: {
                xs: { span: 15, push: 6 },
                sm: { span: 15, push: 6 },
            },
        };
        return (
            <Item {...formItemLayoutWithOutLabel}>
                <WizButton type="dashed" onClick={() => {
                    let size = this.state.answerSize;
                    this[`completionAnswer${size}`] = 0
                    this.setState({ answerSize: ++size })
                }} style={{ width: '60%' }}>
                    <WizIcon type="plus" /> 增加答案
                </WizButton>
            </Item>
        )
    }

    /**
     * 填空答案及添加备选答案
     */
    _completionAnswer(completion, keys, answerKey, idKey, index) {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const formItemLayoutWithOutLabel = {
            wrapperCol: {
                xs: { span: 15, push: 6 },
                sm: { span: 15, push: 6 },
            },
        };
        getFieldDecorator(keys, { initialValue: completion[keys] });
        const _keys = getFieldValue(keys);
        const divider = (
            <WizDivider>
                答案{index + 1}
            </WizDivider>
        )
        const formItems = _keys && _keys.map((k, index) => (
            <Item
                label={index === 0 ? '答案' : '备选答案' + (index + 1)}
                required={false}
                key={k}
            >
                {getFieldDecorator(answerKey + `[${k}]`, {

                    initialValue: (completion[answerKey]) ? completion[answerKey][k] : '',
                    validateTrigger: ['onChange', 'onBlur'],
                    rules: [
                        {
                            required: true,
                            whitespace: true,
                            message: "请输入答案或删除此答案",
                        },
                    ],
                })(
                    <WizInput placeholder="请输入答案" style={{ width: '60%', marginRight: 8 }} />)}
                {answerKey === 'answer0' && _keys.length === 1 ? null : (
                    <WizIcon
                        key={k}
                        className="dynamic-delete-button"
                        type="minus-circle-o"
                        onClick={() => this.remove(k, keys, idKey, answerKey)}
                    />
                )}
            </Item>
        ));
        let add = this[idKey] === 5 ? null : (
            <Item {...formItemLayoutWithOutLabel}>
                <WizButton type="dashed" onClick={() => { this.add(keys, idKey) }} style={{ width: '60%' }}>
                    <WizIcon type="plus" /> 增加备选答案
                </WizButton>
            </Item>
        )
        return [
            <>{divider}</>,
            <>{formItems}</>,
            <>{add}</>
        ]
    }

    /**
     * 主观
     */
    _subjective() {
        const { getFieldDecorator } = this.props.form;
        const { propInfo } = this.props;
        let initialValue = '';
        if (propInfo['type'] === 'Subjective') {
            initialValue = propInfo.answer ||''
        }
        return [
            <Item label="正确答案" >
                {getFieldDecorator('answer', {
                    initialValue,
                  rules: [
                    // { required: true, message: '请输入正确答案' }
                  ],
                })(
                    <WizInput.TextArea maxLength={200} placeholder='请输入正确,最多200字' />
                )}
            </Item>
        ]
    }

  /**
   * 文件上传题
   * @returns {JSX.Element[]}
   * @private
   */
  _fileUpload() {
      const { getFieldDecorator } = this.props.form;
      const { propInfo } = this.props;
      const { type } = this.state;
      let answer = propInfo.type === type ? propInfo.answer : undefined
      return [
        <Item label="正确答案" >
          {getFieldDecorator('answer', {
            initialValue: answer,
            rules: [
              { required: true, message: '请上传正确答案' }
            ],
          })(
            <WizFileUpload limit={-1}
                           beforeUpload={(file, upload, remove) => {
                             let result = true;
                             const isLt1G = file.size / 1024 / 1024 < 500;
                             if (!isLt1G) {
                               Wizmessage.error("文件不得超过500MB!");
                               result = false;
                             }
                             return result;
                           }}
            />
          )}
        </Item>
      ]
    }

  /**
   * 排序题
   * @returns {*[]}
   * @private
   */
    _sort() {
      const { type } = this.state
      const { getFieldDecorator } = this.props.form;
      const { propInfo } = this.props;
      let choiceFormProps = {
        dataSource: undefined,
      }
      if (propInfo && propInfo.options && propInfo.options.length) {
        choiceFormProps['dataSource'] = [...propInfo.options]
      }

      return [
        <Item label="选择设置" key={type}>
          {getFieldDecorator('options', {
            initialValue: propInfo.options
          })(
            <ChoiceForm
              ref={(r) => { this.choiceFormRef = r }}
              key={propInfo ? propInfo.choiceFormKey : 0}
              getDataSource={this.changeOptions}
              {...choiceFormProps}
            />
          )}
        </Item>,
        this._sortAnswer()
      ]
    }
    _sortAnswer() {
      const { getFieldDecorator } = this.props.form;
      const { propInfo } = this.props;
      const { answerSize, type } = this.state;
      let answer = propInfo.type === type ? propInfo.answer : undefined
      if (answerSize <= 0) {
        return
      } else {
        return (
          <Item label="答案设置" key={`${type}-answer`}>
            {getFieldDecorator('answer', {
              initialValue: answer,
              validateTrigger: ['onChange', 'onBlur'],
              rules: [
                { required: true, message: '请填写正确答案' },
                { len: answerSize, message: '排序答案必须' + answerSize + '字符' },
                { validator: (_, value) => {
                    let options = []
                    for (let i = 0; i < answerSize; i++) {
                      options.push(String.fromCharCode(i + 65));
                    }
                    for (let i = 0; i < value?.length; i++) {
                      if(options.indexOf(value.charAt(i)) === -1) {
                        return Promise.reject(new Error(`只允许包含${options}`));
                      }
                    }
                    return Promise.resolve();
                  } },
              ],
            })(
              <WizInput/>
            )}
          </Item>
        )
      }
  }



    /**
     * 题目解析部分
     */
    _analysis() {
        const { getFieldDecorator } = this.props.form;
        const { propInfo } = this.props;
        return (
            <Item label="解析" >
                {getFieldDecorator('analysis', { initialValue: propInfo.analysis })(
                    <WizInput.TextArea maxLength={200} placeholder='请输入解析,最多200字' />
                )}
            </Item>
        )
    }

    /**
     * 修改题目状态
     */
    _changeType = (type) => {
        const { propInfo } = this.props;
        //类型和初始类型不同时(修改题目类型)将form中的答案设为null
        if (propInfo['type'] !== type) {
            this.props.form.setFieldsValue({
                answer: null
            });
        }
        if (type === 'Completion' || type === 'Single' || type === 'Multiple') {
            this.setState({
                type,
                answerSize: 0
            }, () => {
              this.changeSelectDefault(type)
              if (type === 'Completion') {
                this.changeCompletionDefault(propInfo)
              }
            })
            this.answerSize = 0
        } else {
            this.setState({ type })
        }

    }

    /**
     * 表单提交按钮
     */
    _submit() {
        return (
            <Item wrapperCol={{ span: 12, offset: 6 }}>
                <WizRow>
                    <WizCol span={24} style={{ textAlign: 'center' }}>
                        <WizButton type="primary" htmlType="submit">
                            保存
                        </WizButton>
                        <WizButton style={{ marginLeft: 20 }} onClick={this.handleReset}>
                            重置
                        </WizButton>
                    </WizCol>
                </WizRow>
            </Item>
        )
    }

    /**
     * 处理表单提交事件
     */
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                values['validity'] = values['validity'] && values['validity'].format('YYYY-MM-DD')
                let questionImg = values['questionImg']
                if (questionImg && questionImg.length) {
                    values['img'] = questionImg[0]['fileId']
                    delete values['questionImg']
                }
                let { submit } = this.props
                submit && submit(values)
            }
        });
    };

    /**
     * 重置表单
     */
    handleReset = () => {
        let { selects, propInfo } = this.props;
        //重置表单时初始化数据源
        this.isStart = true;
        //初始化题目分类的回调
        this.treeSelectListRef && this.treeSelectListRef._wizSelectOnChange(this.props.selects)
        //多选或者单选时格式化选项
        this.changeSelectDefault()
        //填空题重置
        this.changeCompletionDefault(propInfo)
        //重置表单
        this.props.form.resetFields();
    };


    /**
     * 填空题重置
     */
    changeCompletionDefault = (propInfo) => {
        if (propInfo && propInfo['type'] === 'Completion') {
            let answer = propInfo['answer']
            for (let key in answer) {
                if (key.indexOf('answer') !== -1) {
                    let value = answer[key]
                    let index = key.split('answer')[1];
                    this['completionAnswer' + index] = value.length
                }
            }
            this.setState({ answerSize: propInfo['answerSize'] })
            this.answerSize = propInfo['answerSize']
        } else {
            for (let key in this) {
                if (key.indexOf('completionAnswer') !== -1) {
                    this[key] = 0
                }
            }
            this.answerSize = 0
            this.setState({ answerSize: 0 })
        }
    }

    /**
     * 修改选择题的默认值
     */
    changeSelectDefault = (type) => {
        let { propInfo } = this.props;
        if (!propInfo || !propInfo['type']) {
            if (type === 'Multiple' || type === 'Single' || !type) {
                this.choiceFormRef && this.choiceFormRef['_setState']({
                    dataSource: [{
                        key: 0,
                        name: '',
                        img: '',
                        order: 1
                    }]
                })
            }
        } else {
            if (propInfo['type'] === 'Multiple' || propInfo['type'] === 'Single') {
                let options = propInfo['options']
                if (options && options.length) {
                    for (let index = 0; index < options.length; index++) {
                        options[index]['key'] = index
                        options[index]['order'] = index + 1
                    }
                }
                this.choiceFormRef && this.choiceFormRef['_setState']({ dataSource: options })
            }
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { title } = this.props;
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
        };
        return (
            <WizCard>
                <WizForm
                    {...formItemLayout}
                    onSubmit={this.handleSubmit}
                >
                    {this._base()}
                    {this._subject()}
                    {this._analysis()}
                    {this._submit()}
                </WizForm>
            </WizCard>
        )

    }
}

export default WizForm.create()(SubjectForm);

/**
 * 默认值
 */
SubjectForm.defaultProps = {
    title: '新增题目',
    propInfo: {},
    selects: []

}

/**
 * props入参校验
 */
SubjectForm.propTypes = {
    title: PropTypes.string.isRequired,//卡片标题
    submit: PropTypes.fun,//提交的回调方法
    propInfo: PropTypes.object,//Info信息
    treeSelectList: PropTypes.node,//分类树组件
    treeData: PropTypes.array,//treeData
    selects: PropTypes.array
}
